import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eerxm9hive: FaireBrandEntity = {
  token: "b_eerxm9hive",
  type: "brand",
  name: "Original Moxie",
  avatarUrl:
    "https://cdn.faire.com/fastly/1eeca7d0e19b7be96ad5964aa532d6b575c0b8070423f6259085bf22e18a0c76.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1379e3aa3afa0c32b7a051a961b362f134bb7387480c3ff3c72f0612855710a9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1eeca7d0e19b7be96ad5964aa532d6b575c0b8070423f6259085bf22e18a0c76.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1379e3aa3afa0c32b7a051a961b362f134bb7387480c3ff3c72f0612855710a9.jpeg",
  location: "Ypsilanti , MI, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 11,
  isInsider: true,
  description:
    "There are a few things that set our brand apart from other curly brands on the market and they are our sustainable practices and packaging, professional education, hair type specific solutions, and owner formulated products that are cruelty-free, scented with essential oils, made with organic and wildcrafted ingredients. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:44.478Z",
    importedBy: "entity-db-cli",
  },
};
